import { version } from '../../package.json';

export const environment = {
  production: true,
  version,
  apiUrl: 'https://api.dietranscargo.com/api',
};
